/**
 * Visibility shim
 *
 * @author Nick Dreckshage <ndreckshage@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */

const visibility = (() => {
  if (typeof window === 'undefined') {
    return null;
  }

  return require('visibilityjs');
})();

export default visibility;
